export default {
  "toaster": "_toaster_1ih35_1",
  "toast": "_toast_1ih35_1",
  "description": "_description_1ih35_15",
  "icon": "_icon_1ih35_16",
  "actionButton": "_actionButton_1ih35_23",
  "content": "_content_1ih35_40",
  "closeButton": "_closeButton_1ih35_44",
  "success": "_success_1ih35_57",
  "error": "_error_1ih35_61"
};import "ni:sha-256;Va5SF5t6Sgk4vx9sD0Dis5L12rnvHuvDpZj_rh43rjA";